import { render, staticRenderFns } from "./UserFiles.vue?vue&type=template&id=06052bb3&scoped=true"
import script from "./UserFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFiles.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserFiles.vue?vue&type=style&index=0&id=06052bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06052bb3",
  null
  
)

export default component.exports